import { ComponentProps } from 'react'
import * as React from 'react'
import styled from 'styled-components'

type TProps = {
  labelText?: string
  labelFor?: string
} & Omit<ComponentProps<'input'>, 'type'>

const Radio: React.FC<TProps> = ({
  labelText,
  labelFor,
  onClick,
  ...props
}) => {
  return (
    <StyledWrapper onClick={onClick}>
      <input className="radio-input" type="radio" {...props} />
      <label className="radio-label" htmlFor={labelFor ?? ''}>
        {labelText ?? ''}
      </label>
    </StyledWrapper>
  )
}

export default Radio

const StyledWrapper = styled.div`
  font-weight: 500;

  .radio-input + .radio-label {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 7px;
  }

  input[type='radio'].radio-input {
    display: none;
  }

  input[type='radio'].radio-input + .radio-label:before {
    display: inline-block;
    content: '';
    width: 23px;
    height: 23px;
    border: 1px solid #cccccc;

    border-radius: 50%;
  }

  input[type='radio'].radio-input + .radio-label:after {
    position: absolute;
    left: 0px;
    font-size: 20px;
    color: #ffffff;
    width: 23px;
    height: 23px;
  }

  input[type='radio'].radio-input + .radio-label:after {
    opacity: 0;
  }

  input[type='radio']:checked.radio-input + .radio-label:after {
    opacity: 1;
    content: url('/static/images/channel/radio-active.svg');
  }

  & > .radio-label {
    font-weight: 500;
  }
`
